import React, { ReactElement } from 'react';

import { Icon as SidebarIcon } from '@iconify/react';
import { generatePath } from 'react-router-dom';

import router from '~/core/router';
import { sidebar } from '~/core/sidebar';
import { ChatByIdRoute } from '~/modules/chat';
import { ChatByIdPath, SidebarKey } from '~/modules/chat/constants';
import analytics from '~/services/analytics';

router.addPrivateRoutes([ChatByIdRoute]);

sidebar.addItems({
  a: [
    {
      order: 3,
      key: SidebarKey,
      path: ChatByIdRoute.path,
      getRedirectPath: (): string =>
        generatePath(ChatByIdPath, { chatId: 'index' }),
      onClickCb: (): void => {
        analytics.trackEvent('side_menu_click', {
          button: 'ai_chat',
        });
      },
      getTitle: ChatByIdRoute.getTitle,
      Icon: ({ isActive }): ReactElement => {
        return (
          <SidebarIcon
            style={{ color: isActive ? '#fff' : '#000' }}
            icon="carbon:chat-bot"
          />
        );
      },
    },
  ],
});
